const GOOGLE_AUTH_ERROR_KEYS = {
    GOOGLE_NO_ACCOUNT: 'loginPage.googleNoAccount',
    GOOGLE_ACCOUNT_EXISTS: 'registerPage.googleAccountExists',
};

/** Message for a failed Google OAuth redirect (`?error=…&errorCode=…`), translated when the code is known. */
export function getGoogleAuthRedirectError(search, t) {
    const params = new URLSearchParams(search);
    const message = params.get('error');
    if (!message) return '';
    const key = GOOGLE_AUTH_ERROR_KEYS[params.get('errorCode')];
    return key ? t(key) : message;
}
